export const isNewValueAndSet = (prevValue, newValue) =>
  prevValue !== undefined && prevValue !== newValue;
